import React from 'react';
import classnames from 'classnames';

import RadioWithChild from './radioWithChild';
import UItem from '../item';
import { IProps, IRadioItem } from './type';

const getName = (item: IRadioItem) => {
  return item.dataBind || item.name;
};

// 表单 radio 有子组件的
function URadioChild(props: IProps) {
  const { value, defaultValue, disabled, prefixCls = 'crm-radio-with-child', className, onChange, ...rest } = props;
  // 子项内容改变的时候进行数据更新
  const onValueChange = (e: any) => {
    if (onChange) {
      onChange({
        ...rest,
        value: e,
      });
    }
  };

  const cls = classnames(className, prefixCls);

  // 获取跟父组件defaultValue匹配的所有的子组件默认值
  const childrenDefaultValue: any[] = [];

  if (Array.isArray(props.options)) {
    props.options.forEach((itemO) => {
      if (itemO.value === defaultValue) {
        if (Array.isArray(itemO.childrens)) {
          itemO.childrens.forEach((itemC) => {
            if (itemC.defaultValue) {
              childrenDefaultValue.push({ name: getName(itemC), value: itemC.defaultValue });
            }
          });
        }
      }
    });
  }

  return (
    <UItem
      {...rest}
      className={cls}
      initialValue={value || defaultValue}
      validateTrigger="onChange"
    >
      <RadioWithChild {...rest} onChange={onValueChange} />
    </UItem>
  );
}

export default URadioChild;
